const state = {
  isNew: false
}

const mutations = {
  TOGGLE_IS_NEW (state, value) {
    state.isNew = value
  }
}

export default {
  state,
  mutations
}
